/**
 * Overview page (the front door) — a thin shell over the Scorecard matrix. Scope comes
 * from useScope; the data-bound composition + honest states live in ScorecardBody.
 *
 * THE INTRO COPY IS GONE (19 Aug 2026, Mike). The paragraph sold the product and taught
 * three clicks that the page now labels in place: a pillar row says "show trend" and a
 * metric name carries an arrow. The scope it printed is in the top bar. The matrix is
 * the page; the title is enough.
 *
 * THE EYEBROW STAYS, in the shape Margin and Capacity use: the domains this page covers,
 * then its subject, in the domain's own accent (config/nav.ts gives Overview var(--brand)).
 * What it says has changed — "Front door · reframed scorecard" named our internal history,
 * not anything the reader can see.
 *
 * THE "CHARTS" TAB IS GONE (10 Aug 2026). It rendered every matrix metric as its own
 * card — a wall of nineteen, which flattened away the pillar grouping the matrix was
 * already built on and made the only interesting comparisons impossible to see: Revenue,
 * blended forecast and firm are one story told by three rows, and three separate cards
 * cannot show the gap between them. The trends now expand from the pillar headers, next
 * to the numbers they explain, so there is one surface instead of two views of it.
 * `?view=charts` on an old link resolves to the matrix rather than 404ing.
 */

import React from 'react'
import ScopeBar from '../components/kit/ScopeBar'
import { entityAxis, grainAxis, periodAxis } from '../components/kit/scopeAxes'
import { useScope } from '../hooks/useScope'
import ScorecardBody from './ScorecardBody'

export default function Scorecard(): React.JSX.Element {
  const scope = useScope()
  return (
    <div className="cx-fade cx-page py-6 pb-20 space-y-4">
      <header>
        <div className="mb-1.5 font-mono text-[10px] uppercase tracking-[.16em]" style={{ color: 'var(--brand)' }}>
          All pillars · Plan vs actual
        </div>
        <h1 className="text-[26px] font-bold tracking-[-.02em] text-ink">Overview</h1>
      </header>
      <ScopeBar axes={[entityAxis(scope), grainAxis(scope), periodAxis()]} />
      <ScorecardBody scope={scope} />
    </div>
  )
}
